import { ENV } from "../Utils";

export class StudentAPI {
  baseApi = ENV.BASE_API;

  // Obtener estudiantes de una institución con paginación
  async getStudents(accessToken, institutionId, { page = 1, limit = 10 } = {}) {
    try {
      const url = `${this.baseApi}/students/${institutionId}?page=${page}&limit=${limit}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result; // {code, message, students, pagination: {...}}
    } catch (error) {
      console.error("Error en getStudents:", error);
      throw error;
    }
  }

  async getStudentsbyID(accessToken, studentId) {
    try {
      const url = `${this.baseApi}/student/${studentId}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result; // {code, message, students, pagination: {...}}
    } catch (error) {
      console.error("Error en getStudents:", error);
      throw error;
    }
  }
  // Obtener estudiantes por classnumber
  // Debido a la lógica del controlador, asumimos que cambias la ruta a POST /students/class/:id
  // y envías { classnumber: "X" } en el body.
  async getStudentsByClassnumber(accessToken, institutionId, classnumber, { page = 1, limit = 10 } = {}) {
    try {
      const url = `${this.baseApi}/students/class/${institutionId}?page=${page}&limit=${limit}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ classnumber }),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result; // { code, message, students, pagination: {...} }
    } catch (error) {
      console.error("Error en getStudentsByClassnumber:", error);
      throw error;
    }
}

  // Crear un nuevo estudiante
  // formData con campos: name, surname, email, password, classnumber, [avatar opcional]
  async createStudent(accessToken, institutionId, formData) {
    try {
      const url = `${this.baseApi}/student/create/${institutionId}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result; // {code, message, student, user, success}
    } catch (error) {
      console.error("Error en createStudent:", error);
      throw error;
    }
  }

  // Actualizar un estudiante
  // institutionId, studentId, formData (puede contener avatar, password, name, surname, etc.)
  async updateStudent(accessToken, institutionId, studentId, formData) {
    try {
      const url = `${this.baseApi}/student/update/${institutionId}/${studentId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result; // {code, message, student, user}
    } catch (error) {
      console.error("Error en updateStudent:", error);
      throw error;
    }
  }

  // Eliminar un estudiante
  // institutionId, studentId
  async deleteStudent(accessToken, institutionId, studentId) {
    try {
      const url = `${this.baseApi}/student/delete/${institutionId}/${studentId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result; // {code, message}
    } catch (error) {
      console.error("Error en deleteStudent:", error);
      throw error;
    }
  }

  // Añadir calificación a un estudiante
  // { teacherId: "X", sceneId: "Y"(opcional), puntuation: 95(opcional) }
  async createCalification(accessToken, studentId, calificationData) {
    try {
      const url = `${this.baseApi}/student/calification/${studentId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(calificationData),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result; // {code, message, student}
    } catch (error) {
      console.error("Error en createCalification:", error);
      throw error;
    }
  }
}
